import { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const WeatherInfo = ({ ciudad, fecha, hora }) => {
  const { t, i18n } = useTranslation('reports');
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const apiKey = "805d50f50fbe4da49ba125331252609"; // gratis en weatherapi.com
        const lang = i18n.language?.startsWith('en') ? 'en' : 'es';
        const res = await fetch(
          `https://api.weatherapi.com/v1/forecast.json?key=${apiKey}&q=${ciudad}&days=3&lang=${lang}`
        );
        const data = await res.json();

        if (data.forecast) {
          // Buscar el día y la hora más cercanos
          const day = data.forecast.forecastday.find(
            (d) => d.date === fecha // formato esperado: "2025-09-28"
          );

          if (day) {
            const targetHour = parseInt(hora.split(":")[0], 10); // ej: "11:00" -> 11
            const forecastHour = day.hour.find(
              (h) => new Date(h.time).getHours() === targetHour
            );
            setWeather(forecastHour || day.day);
          }
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchWeather();
  }, [ciudad, fecha, hora]);

  if (loading) return <CircularProgress size={20} />;

  if (!weather) {
    return <Typography variant="body2">{t('weather.noData')}</Typography>;
  }

  return (
    <Box sx={{ mt: 2, textAlign: "center" }}>
      <Typography variant="body2">
        {ciudad} | {weather.condition.text} | 🌡️ {weather.temp_c}°C
      </Typography>
      <img src={`https:${weather.condition.icon}`} alt={weather.condition.text} />
    </Box>
  );
};

export default WeatherInfo;
